import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BrandVoiceService {
    /**
     * Get array of brand voices
     * @returns BrandVoiceBoInterface
     * @throws ApiError
     */
    static brandVoiceGetAll() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/brand-voice',
        });
    }
    /**
     * Upsert a brand voice
     * @param requestBody
     * @returns BrandVoiceBoInterface
     * @throws ApiError
     */
    static brandVoiceUpsert(requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/brand-voice',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get brand voice by id
     * @param brandVoiceId
     * @returns BrandVoiceBoInterface
     * @throws ApiError
     */
    static brandVoiceGetById(brandVoiceId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/brand-voice/{brandVoiceId}',
            path: {
                'brandVoiceId': brandVoiceId,
            },
        });
    }
    /**
     * Generate a new brand voice
     * @param requestBody
     * @returns boolean
     * @throws ApiError
     */
    static brandVoiceGenerate(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/brand-voice/generate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
